export const FREE_INSTALLMENTS_CODE = "free-installments";
export const MAX_INSTALLMENTS_COUNT = 12;
export const PAYMENT_METHODS_PRODUCT_ATTR_CODE = "payment-methods";
export const IGNORE_TAX_EXEMPTION_CODE = "ignore-tax-exemption";
